// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__jfGkJ","notes":"Notes_notes__GQm_-"};